import QueryString from "qs";
import useSWR from "swr";
import { useLocation } from "react-router-dom";
import Pagination from "../../../../Components/Common/Pagination/Pagination";
import useTable from "../../../../hooks/useTable";
import { modelTestUrls } from "../../../../Api/Auth/ApiUrls";
import Table from "../../../../Components/Common/Table";
import TableHead from "../../../../Components/Common/TableHead";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import { simulatorTabsData } from "../../../../data/SidebarData";
import { Loader } from "../../../../Components/Common/Loader";
import NoData from "../../../../Components/Common/NoData";
import FreeModelTestRow from "../Components/FreeModelTestRow";

const tableColumnData = [
  { id: "email", label: "Email" },
  { id: "modelTest", label: "Model Test" },
  { id: "createdAt", label: "Created" },
];

const FreeModelTestList = () => {
  const location = useLocation();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate } = useSWR(
    modelTestUrls.getFreeModelTestTaker(apiQueryString)
  );

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={simulatorTabsData} />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <FreeModelTestRow key={row._id} row={row} mutate={mutate} />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default FreeModelTestList;
